import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { TimeEnum } from "../../../../lib/enums";
import { FILTER_KEYWORDS } from "../../../search/consts";
import { getSearchPivotLink } from "../../util";
import SampleReportGridUriStats from "../details/SampleReportGrid/SampleReportGridUriStats";
import SampleReportGridClassification from "../details/SampleReportGrid/SampleReportGridClassification";
import { Grid } from "../../../../components/Grid";
import { Name } from "../../../search/schema/components";

const SourcesNetworkReferences = ({ urls }) => {
  const gridSchema = {
    fields: [
      {
        name: "network_references_url",
        displayTitle: "URL",
        className: "overflow-ellipsis",
        component: data => (
          <Name
            data={{
              file_name: data.value,
              int_submission_analyzer: 1
            }}
            className="sample-report-grid__link"
          />
        )
      },
      {
        name: "network_references_classification",
        displayTitle: "Classification",
        className: "overflow-ellipsis",
        component: data => <SampleReportGridClassification url={data.value} />,
        style: {
          width: "230px"
        }
      },
      {
        name: "network_references_threat_counts",
        displayTitle: "Threat counts",
        className: "overflow-ellipsis",
        component: data => <SampleReportGridUriStats url={data.value} />,
        style: {
          width: "230px",
          textAlign: "center"
        }
      }
    ]
  };

  return (
    <>
      {urls.length ? (
        <Grid schema={gridSchema} data={urls} />
      ) : (
        <p>
          <b>No Network Locations for This Sample</b>
        </p>
      )}
    </>
  );
};

SourcesNetworkReferences.propTypes = {
  urls: PropTypes.arrayOf(PropTypes.object)
};

export default SourcesNetworkReferences;
